import React from 'react';
import { ReportData } from '../../types/report.types';
import HtmlEditor from '../HtmlEditor';

interface FindingsEditorProps {
  reportData: ReportData;
  onHtmlChange: (field: keyof ReportData, value: string) => void;
  onDataChange: (field: string, value: any) => void;
  onTableChange: (field: string, value: number) => void;
}

const FindingsEditor: React.FC<FindingsEditorProps> = ({
  reportData,
  onHtmlChange,
  onDataChange,
  onTableChange
}) => {
  return (
    <div className="space-y-8">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-800">Findings</h3>
          <p className="text-sm text-gray-600 mt-1">Edit the findings content below</p>
        </div>
        <div className="p-6">
          <HtmlEditor
            field="findings"
            title="Findings"
            reportData={reportData}
            onHtmlChange={onHtmlChange}
          />
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-800">Severity Counts</h3>
          <p className="text-sm text-gray-600 mt-1">Calculated automatically from findings</p>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-2 gap-6">
            {Object.entries(reportData.open_close_counts_by_severity || {}).map(([severity, counts]) => (
              <div key={severity} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <h4 className="font-semibold text-lg mb-4 text-gray-800">{severity}</h4>
                <div className="space-y-4">
                  {Object.entries(counts).map(([type, value]) => (
                    <div key={type} className="flex justify-between items-center">
                      <span className="text-gray-600 font-medium">{type}:</span>
                      <div className="flex items-center gap-2">
                        <input
                          type="number"
                          value={value}
                          disabled
                          readOnly
                          className="w-20 border border-gray-300 rounded-lg px-3 py-1 text-center bg-gray-100 text-gray-700 font-bold cursor-not-allowed"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-3 gap-6">
            {[
              { label: 'Total Open', value: reportData.total_open || 0 },
              { label: 'Total Closed', value: reportData.total_closed || 0 },
              { label: 'Total Findings', value: reportData.total_findings || 0 }
            ].map(({ label, value }) => (
              <div key={label} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <h4 className="font-semibold text-lg mb-4 text-gray-800">{label}</h4>
                <div className="flex items-center gap-2">
                  <input
                    type="number"
                    value={value}
                    disabled
                    readOnly
                    className="flex-1 border border-gray-300 rounded-lg px-3 py-1 text-center bg-gray-100 text-gray-700 font-bold cursor-not-allowed"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindingsEditor; 